import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		orderNo: sessionStorage.getItem('orderNo') || '',
		userinfo: {},
	},
	getters: {
		// 获取缓存数据
		getOrderNo: (state) => {
			return state.orderNo;
		},
		// 获取缓存数据
		getUserinfo: (state) => {
			return state.userinfo;
		},
	},
	mutations: {
		// 更新缓存数据
		setOrderNo(state, data) {
			state.orderNo = data;
			sessionStorage.setItem('orderNo', data);
		},
		// 更新缓存数据
		clearOrderNo(state) {
			state.orderNo = '';
		},
		// 更新缓存数据
		setUserinfo(state, data) {
			state.userinfo = data;
			sessionStorage.setItem('userinfo', JSON.stringify(data));
		},
		// 更新缓存数据
		clearUserinfo(state) {
			state.userinfo = {};
		},
	},
	actions: {},
	modules: {},
});
